/**
 * A component to search
 *
 * @param dropDown populate dropdown with items must be [{value: '', lable: ''}]
 * @param performSearch emits an event notifying the component to run the search
 * @param placeholder set the string that is to be used as the placeholder. Does NOT need to be translated beforehand
 * @param error set the error text. Input must be a string.
 */
export const SearchNew: ng.IComponentOptions = {
  bindings: {
    dropDown: '<',
    performSearch: '&',
    placeholder: '@',
    error: '@'
  },
  templateUrl: 'app/angularJS/components/search-new/search-new.html',
  controller: 'SearchNewController',
  controllerAs: 'vm'
};